import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TransferSchoolAou } from '@ascschool/model/transfer/transfer-school-aou.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class TransferSchoolService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
    })
  };
  version = 'v1.0';
  url = environment.apiUrl + this.version + '/DisTransferSchools';
  constructor(private http: HttpClient) {
  }

  getTransferSchool(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/Get?' + queryString);
  }

  getTransferSchoolById(id: any): Observable<any> {
    return this.http.get(this.url + `/GetById/${id}`, this.httpOptions);
  }

  getStuByCode(code: any): Observable<any> {
    return this.http.get(this.url + `/GetStuByCode/${code}`, this.httpOptions);
  }

  getStuByEatos(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/GetStuByEatos?' + queryString);
  }
  getEatos(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/GetSelectPagingEatos?' + queryString);
  }
  addOrUpdatetransferSchool(transferSchool: any): Observable<any> {
    return this.http.post(this.url + '/Add', transferSchool, this.httpOptions);
  }

  updatetransferSchool(transferSchool: any): Observable<any> {
    return this.http.put(this.url + `/Update/${transferSchool.id}`, transferSchool, this.httpOptions);
  }

  deletetransferSchool(listId: number[]): Observable<any> {
    return this.http.post(this.url + `/Delete`, listId, this.httpOptions);
  }
  export(filter: any) {
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }
}
